// Swap English weekday/month names inside an already-formatted date string for the
// interface language. Order, digits, separators and timezone handling are untouched.
import i18n from "@/i18n";

const WD_LONG = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
const WD_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const M_LONG = ["January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"];
const M_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export function localizeDateNames(text, { longMonth = false, lower = false } = {}) {
    if (!text || typeof text !== "string" || i18n.language !== "fi") return text;
    const map = {};
    WD_LONG.forEach((w, i) => { map[cap(w)] = i18n.t(`days.${w}`); map[WD_SHORT[i]] = i18n.t(`weekdaysShort.${w}`); });
    M_LONG.forEach((m, i) => { if (m !== "May") map[m] = i18n.t(`months.${i + 1}`); });
    M_SHORT.forEach((m, i) => { if (m !== "May") map[m] = i18n.t(`monthsShort.${i + 1}`); });
    map.Sept = i18n.t("monthsShort.9");
    map.May = longMonth ? i18n.t("months.5") : i18n.t("monthsShort.5");
    const re = new RegExp(`\\b(${Object.keys(map).sort((a, b) => b.length - a.length).join("|")})\\b`, "g");
    return text.replace(re, (w, _g, offset) => {
        const fi = map[w];
        return offset === 0 && !lower ? cap(fi) : fi.toLowerCase();
    });
}
